import { Component, OnInit, ViewChild, ElementRef, ViewContainerRef, Input } from '@angular/core';
import { AdminPortalAPIService } from '../../entity-services/admin-portal-api.service';
import { UpperCasePipe } from '@angular/common/src/pipes';
import { GridService } from '../../entity-services/grid.service';
import { DynamicGridComponent } from '../../components/dynamic-grid/dynamic-grid.component';
import { columnDataType, GridColumnDefinition } from '../../components/dynamic-grid/grid';
import { forEach } from '@angular/router/src/utils/collection';
import { isJsObject } from '@angular/core/src/change_detection/change_detection_util';
import * as go from "gojs";
import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs/Observable';
import { ComponentInteractionService } from '../../entity-services/component-interaction.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SchemaPropertyNode } from "../../components/SchemaPropertyNode";
import { EntityConfigurationService } from "../../entity-services/features/entityConfiguration/entity-configuration.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { UUID } from "angular2-uuid";
import { TimeseriesChartComponent } from '../../components/timeseries-chart/timeseries-chart.component';
import { InputPropertyList } from '../../entity-services/InputPropertyList';

@Component({
  selector: 'app-entity-demo',
  template: `<div id="sample">
  <div class="maskDiv" *ngIf="entityConfigurationService.isOperationInProgress">
    <i class="fa fa-gear fa-spin maskSpin"></i>
  </div>
  <div style="width: 100%; display: flex; justify-content: space-between; height: calc(100vh - 67px);float: left; overflow-x: auto;overflow-y: hidden;">    
    <div id="entityTypes" class="entityTypeSection pull-left">
      <ul id="grouplist" class="list-group">
        <li class="list-group-item header">Entity Schema
        </li>
        <li class="list-group-item" [ngClass]="{'active': selectedEntityType == item}" [ngStyle]="{ 'background-color': this.getEntityTypeColor(item)}"
          (click)="OnClickEntityType(item)" *ngFor="let item of entityTypes">
          {{ item}}
        </li>
      </ul>
    </div>

    <div id="myPaletteDiv" class="pull-left" style="display:none;width: 100px; margin-right: 2px; background-color: whitesmoke; border: solid 1px black"></div>

    <div id="entityInstanceDiv" class="entityInstanceSection pull-left" *ngIf="!!selectedEntityType">
      <ul class="list-group">
        <li class="list-group-item header">{{selectedEntityType}} Instance
          <app-entity-instance-register-container [entitySchema]="selectedSchema" [isEdit]="false" (saveEntityEvent)="onSaveEntityRegister($event)"></app-entity-instance-register-container>
        </li>
        <li class="list-group-item" [ngClass]="{'active': selectedEntityInstance == item}" (click)="OnClickEntityInstance(item)"
          draggable="true" (dragstart)="dragStart($event,item.id,'Node')" *ngFor="let item of entityInstances">
          {{ item.name}}

          <app-entity-instance-register-container *ngIf="selectedEntityInstance == item" [isEdit]="true" [entitySchema]="selectedSchema"
            [editableEntity]="item" (saveEntityEvent)="onSaveEntityRegister($event)"></app-entity-instance-register-container>

        </li>
      </ul>
    </div>

    <div [hidden]="IsHideRelationPanel" id="showRelationDiv" class="pull-left" style="width:15%;">
      <div id="relationshipPaletteDiv" style="display:none;width: 100px;height:90%; margin-right: 2px; background-color: whitesmoke; border: solid 1px black"></div>

      <div class="relationTypesSection">
        <ul class="list-group">
          <li class="list-group-item header" style="height:40px;">Relationships Type
            <i class="fa fa-plus-square add-entity-icon rightAddbutton" (click)="openAddRelationTypeDialog(addRelationType)"></i>
          </li>
          <li class="list-group-item" draggable="true" (dragstart)="dragStart($event,item.id,'Link')" *ngFor="let item of relationTypes">
            {{item.text}}
          </li>
        </ul>

        <div>
          <button data-toggle="modal" class="btn btn-info addRelation btn-sm" (click)="hideRelationTypePanel()">Close</button>
        </div>
      </div>


    </div>

    <div style="flex-grow: 1; height: calc(100vh - 80px); margin-top:10px;" class="pull-left">
      <div>
        <button class="btn btn-info btn-sm" (click)="show()" [hidden]="!IsHideRelationPanel">Relationship Types</button>
        
        <app-entity-type-definition (addSchema)="OnSchemaAdd($event)"></app-entity-type-definition>
        <div class="pull-right">
          <button class="btn btn-info btn-sm" (click)="uploadEntity.click()">Upload Entities</button>
          <input type="file" class="uploadEntity" (change)="FileChangeEvent($event)" #uploadEntity>
          <button class="btn btn-info btn-sm" (click)="SaveEntityDiagramRelations()">Save Entities</button>
        </div>
      </div>

      <div id="myDiagramDiv" (drop)="dropOnDiagram($event)" (dragover)="dragOverOnDiagram($event)" style="margin-top:10px; height: calc(100vh - 114px);border:1px solid #ccc;"></div>
    </div>

    <div [hidden]="IsHideEntityDetails" class="pull-left" style="height:calc(100vh - 77px);position:relative; max-width:300px; margin-left:4px;background-color:#fff; border: solid 1px#ccc; margin-top: 10px;">

        <div class="detailsection-header">
            <i (click)="showEntityProperties()" class="fa fa-close">
            
            </i>
          </div>

      <div style="overflow-y: auto; z-index:9;width:100%;height: calc(100vh - 125px);margin-top:45px;">
    
      <table>
        <tbody>
          <tr *ngFor="let property of stringProperties; let i = index">
            <td style="padding-left: 10px;">
              <b> {{ property.name }} : </b>
            </td>
            <td>{{ property.value }}</td>
          </tr>
          <tr *ngFor="let property of arrayProperties; let i = index">
            <td>
              <b>{{ property.name }} :</b>
            </td>
            <td>
              <select class="form-control"    placeholder="property.name">
                <option value="">Please select a {{property.name}}</option>
                  <option  *ngFor="let role of property.value"  >{{role }}</option>
                  </select>
            </td>
          </tr>
          <tr *ngIf="isTimeseriesExist">
            <td>
              <b>Timeseries Id :</b>
            </td>
            <td>
              <select class="form-control pull-left" title="Select Timeseries Id" (change)="OnChnageTimeSeriesId($event.target.value)">
                <option value="" selected>Select Timeseries Id</option>
                <option *ngFor="let tid of timeseriesIdList" [value]="tid.value">{{tid.value}}</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
     
    </div>
  </div>



</div>

<!-- Modal for Timeseries-->


<div id="displayTimeseriesModel" class="modalPopup">
  <!-- Modal content -->

  <div class="modalPopup-content">

    <div style="text-align: right">
      <i (click)="closeTimeseriesMetrix()" class="fa fa-close">
            
        </i>
    </div>
    <span>
      <h2> Timeseries Metrics</h2>
    </span>

    <app-timeseries-chart style="width: 100%"></app-timeseries-chart>


    <div style="text-align: center">
      <br/>
      <br/>
      <br/>
      <button type="button" class="btn btn-info " (click)="closeTimeseriesMetrix()">Close</button>
    </div>
  </div>

</div>


<!-- Create Custome Entity -->
<div id="createCustomeEntityModel" class="modalPopup">
  <!-- Modal content -->

  <div class="modalPopup-content">

    <div style="text-align: right">
      <span class="buttonClose" (click)="closeTimeseriesMetrix()">&times;</span>
    </div>
    <span>
      <h2> Add Custome Entity</h2>
    </span>

    <div>
      <div class="form-group">
        <label for="key">Key:</label>
        <input type="text" class="form-control" id="email">
      </div>
      <div class="form-group">
        <label for="pwd">Data Type:</label>
        <input type="text" class="form-control" id="pwd">
      </div>

      <button type="submit" class="btn btn-default">Add</button>
    </div>


    <div style="text-align: bottom">
      <br/>
      <br/>
      <br/>
      <button type="button" class="btn btn-outline-dark btn-md" (click)="closeTimeseriesMetrix()">Close</button>
    </div>
  </div>

</div>



<!-- Modal for Add Relation-->
<ng-template #addRelationType let-c="close" let-d="dismiss">

  <div class="modal-header">
    <h6 class="modal-title">Add Relationship Type</h6>
    <button type="button" class="close" (click)="d('Cross click')">&times;</button>
  </div>
  <div class="modal-body">
    <div class="row form-group">
      <div class="col-md-1"> &nbsp;</div>
      <label for="lblRelationName col-md-1">Relationship Name:</label>
      <div class="col-md-1"> &nbsp;</div>
      <input class="form-control col-md-4" [(ngModel)]="newRelatioName" type="text">
    </div>

  </div>
  <div class="modal-footer">
    <button class="btn btn-primary btn-sm" (click)="addNewRelations();c('Close click');" data-dismiss="modal">Add</button>
    <button class="btn btn-outline-dark btn-sm" (click)="c('Close click');">Close</button>
  </div>
</ng-template>`,
  styles: [`#entityInstanceDiv .list-group,.entityTypeSection .list-group{height:calc(100vh - 79px);overflow-y:auto;padding-left:0}.relationTypesSection .list-group{position:absolute;top:0;bottom:45px;overflow-y:auto;left:0;right:0;margin-right:2px;padding-left:0}#entityInstanceDiv .list-group:hover{overflow-y:auto}#entityInstanceDiv .list-group-item{word-wrap:break-word}.entityTypeSection{margin-right:2px;background-color:#f5f5f5;border:1px solid #ccc;margin-top:10px;padding:0}.entityTypeSection .header{background:#87ceeb}.entityInstanceSection{margin-right:2px;background-color:#f5f5f5;border:1px solid #ccc;margin-top:10px}.entityInstanceSection .list-group{overflow-y:hidden}.entityInstanceSection .list-group:hover{overflow-y:auto}.entityInstanceSection .list-group-item.header{background:#87ceeb}.entityInstanceSection .list-group-item{background:#f5f5f5}.entityInstanceSection .list-group-item:hover,.list-group .list-group-item.header{background:#87ceeb}.addRelation{display:block}.uploadEntity{display:none}.modalPopup{display:none;position:fixed;z-index:30;padding-top:50px;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4);font-size:16px}.modalPopup-content{background-color:#fefefe;margin:auto;padding:40px;border:1px solid #888;width:70%;height:90%;overflow-y:scroll;font-size:16px}.button{background-color:#dd4848;border:none;color:#fff;padding:10px;text-align:center;text-decoration:none;display:inline-block;font-size:16px;margin:4px 2px;cursor:pointer;border-radius:12px}.buttonClose{background-color:#dd4848;border:none;color:#fff;padding:2px;text-align:center;text-decoration:none;display:inline-block;font-size:22px;margin:2px;cursor:pointer;border-radius:12px}.modal-header{background:#4c4c4c;background:-webkit-gradient(linear,left top,left bottom,from(#4c4c4c),color-stop(7%,#2c2c2c),color-stop(7%,#2c2c2c),color-stop(12%,#595959),color-stop(14%,#474747),color-stop(14%,#474747),color-stop(25%,#666),color-stop(51%,#000),color-stop(60%,#111),color-stop(76%,#2b2b2b),color-stop(91%,#1c1c1c),to(#131313));background:linear-gradient(to bottom,#4c4c4c 0,#2c2c2c 7%,#2c2c2c 7%,#595959 12%,#474747 14%,#474747 14%,#666 25%,#000 51%,#111 60%,#2b2b2b 76%,#1c1c1c 91%,#131313 100%);color:#f5f5f5}.modal-header .close,.modal-header .close:hover{color:#fff;float:left}.adminModalResiable .modal-content{overflow:hidden;resize:both}.regular-checkbox{-webkit-appearance:none;background-color:#fafafa;border:1px solid #cacece;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);padding:7px;border-radius:3px;display:inline-block;position:relative;margin-bottom:-3px}.required{color:red}.regular-checkbox:active,.regular-checkbox:checked:active{-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1)}.regular-checkbox:checked{background-color:red;border:1px solid red;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);color:#99a1a7}.hidden{display:none}#showRelationDiv{margin-top:10px;margin-right:4px;background:#f5f5f5;border:1px solid #ccc;min-width:160px;position:relative}.list-group-item{padding:.3rem 1.6rem .3rem 1rem!important;display:flow-root;-ms-flex-flow:nowrap;flex-flow:nowrap}.addRelation{position:absolute;bottom:5px;right:5px}.list-group-item.active{border:5px solid #00f}.entityInstanceSection .list-group-item.active{color:#000!important}.entityTypeSection .list-group-item{color:#f5f5f5!important}.maskDiv{padding:50%;background:#add8e6;position:fixed;z-index:80000;height:100%;width:100%;overflow:show;margin:auto;top:0;left:0;bottom:0;right:0;opacity:.5}.maskDiv .maskSpin{font-size:36px;color:green;z-index:90000}.rightAddbutton{position:absolute;top:10px;right:5px}.add-entity-icon{font-size:14px;color:green;margin-left:11px}.detailsection-header{background:#5bc0de;float:left;width:100%;text-align:right;padding:5px}.timeseriespopup-header{background:#5bc0de;float:left;width:100%;padding:5px}`],
  providers: [GridService]
})
export class EntityDemoComponent implements OnInit {

  myDiagram: any;
  relationshipPalette: any;
  newRelatioName: string;
  IsHideRelationPanel: boolean = true;
  graphLinkArray: any[];
  $: any;
  entityArray: any;
  entityProperties: any[] = [];
  IsHideEntityDetails: boolean = true;
  entities: any[] = [];
  entityTypes: any[];
  selectedEntityType: any;
  entityInstances: any[];
  entityInstancePaletteDiv: any;
  isSaveEnabled = false;
  arrayProperties: ArrayProperties[];
  stringProperties: StringProperties[];
  timeseriesIdList: ArrayProperties[];
  isTimeseriesExist: boolean = false;
  relationTypes: { id: string, text: string }[] = [];
  entitySchemaList: any[] = [];
  selectedSchema: any;
  selectedEntityInstance: any;
  colorArr = [];
  relationsTobeDeleted=[];

  @Input() inputProperty: InputPropertyList;

  ngOnInit() {
    
    this.entityConfigurationService.assignInputPropertyValues(this.inputProperty);
    this.getEntitySchemaList();
    this.getRelationTypes();
    this.createERDiagram();
    document.getElementById("displayTimeseriesModel").style.display = "none";

  }
  constructor(private http: Http, private componentInteractionService: ComponentInteractionService, private modalService: NgbModal,
    public entityConfigurationService: EntityConfigurationService, private toastr: ToastsManager, vcr: ViewContainerRef) {
      
          this.toastr.setRootViewContainerRef(vcr);
      
        }

  OnChnageTimeSeriesId(timeseriesId) {
    this.componentInteractionService.NotifyTimeseriesIdChangeEvent(timeseriesId);
    document.getElementById("displayTimeseriesModel").style.display = "block";
  }
  closeTimeseriesMetrix() {
    document.getElementById("displayTimeseriesModel").style.display = "none";
  }

  createERDiagram() {

    var $ = go.GraphObject.make;  // for conciseness in defining templates
    this.$ = $;
    var thisObj = this;
    var yellowgrad = $(go.Brush, "Linear", { 0: "rgb(254, 201, 0)", 1: "rgb(254, 162, 0)" });
    var greengrad = $(go.Brush, "Linear", { 0: "#98FB98", 1: "#9ACD32" });
    var bluegrad = $(go.Brush, "Linear", { 0: "#B0E0E6", 1: "#87CEEB" });
    var redgrad = $(go.Brush, "Linear", { 0: "#C45245", 1: "#871E1B" });
    var whitegrad = $(go.Brush, "Linear", { 0: "#F0F8FF", 1: "#E6E6FA" });

    var bigfont = "bold 13pt Helvetica, Arial, sans-serif";
    var smallfont = "bold 11pt Helvetica, Arial, sans-serif";

    // Common text styling
    function textStyle() {
      return {
        margin: 6,
        wrap: go.TextBlock.WrapFit,
        textAlign: "center",
        editable: true,
        font: bigfont
      }
    }

    this.myDiagram =
      $(go.Diagram, "myDiagramDiv",
        {

          grid: $(go.Panel, "Grid",
            $(go.Shape, "LineH", { stroke: "lightgray", strokeWidth: 0.5 }),
            $(go.Shape, "LineH", { stroke: "gray", strokeWidth: 0.5, interval: 10 }),
            $(go.Shape, "LineV", { stroke: "lightgray", strokeWidth: 0.5 }),
            $(go.Shape, "LineV", { stroke: "gray", strokeWidth: 0.5, interval: 10 })
          ),
          allowDrop: true,  // must be true to accept drops from the Palette
          "draggingTool.dragsLink": true,
          "draggingTool.isGridSnapEnabled": true,
          "linkingTool.isUnconnectedLinkValid": true,
          "linkingTool.portGravity": 20,
          "relinkingTool.isUnconnectedLinkValid": true,
          "relinkingTool.portGravity": 20,
          "relinkingTool.fromHandleArchetype":
          $(go.Shape, "Diamond", { segmentIndex: 0, cursor: "pointer", desiredSize: new go.Size(8, 8), fill: "tomato", stroke: "darkred" }),
          "relinkingTool.toHandleArchetype":
          $(go.Shape, "Diamond", { segmentIndex: -1, cursor: "pointer", desiredSize: new go.Size(8, 8), fill: "darkred", stroke: "tomato" }),
          "linkReshapingTool.handleArchetype":
          $(go.Shape, "Diamond", { desiredSize: new go.Size(7, 7), fill: "lightblue", stroke: "deepskyblue" }),
          // have mouse wheel events zoom in and out instead of scroll up and down
          "toolManager.mouseWheelBehavior": go.ToolManager.WheelZoom,
          // support drag-and-drop from the Palette
          initialAutoScale: go.Diagram.Uniform,
          "linkingTool.direction": go.LinkingTool.ForwardsOnly,
          initialContentAlignment: go.Spot.Center,
          layout: $(go.LayeredDigraphLayout, { isInitial: false, isOngoing: false, layerSpacing: 50 }),
          "undoManager.isEnabled": true
          ,
          allowCopy: false,
          allowInsert: false,
          allowLink: false,
          isReadOnly: false,
        });
    let self = this.myDiagram;
    let selfThis = this;
    // when the document is modified, add a "*" to the title and enable the "Save" button
    this.myDiagram.addDiagramListener("Modified", function (e) {
      console.log(e);
      selfThis.isSaveEnabled = true;
      var idx = document.title.indexOf("*");
      if (self.isModified) {
        if (idx < 0) document.title += "*";
      } else {
        if (idx >= 0) document.title = document.title.substr(0, idx);
      }
    });
    var mydiagramObj = this.myDiagram;
    
    this.myDiagram.addDiagramListener("SelectionDeleting", function (e) {
      mydiagramObj.selection.each(function (part) {
        if (part instanceof go.Node) {
          //console.log(part.data);
          selfThis.relationsTobeDeleted= selfThis.relationsTobeDeleted.concat(mydiagramObj.model.linkDataArray.filter(link=>link.from===part.data.id || link.to===part.data.id));
        }
        else if(part instanceof go.Link){
          selfThis.relationsTobeDeleted.push(part.data);
        }
      });
    });
    
    var defaultAdornment =
      $(go.Adornment, "Spot",
        $(go.Panel, "Auto",
          $(go.Shape, { fill: null, stroke: "dodgerblue", strokeWidth: 4 }),
          $(go.Placeholder)),
        // the button to create a "next" node, at the top-right corner
        $("Button",
          {
            alignment: go.Spot.TopRight,
            click: addNodeAndLink
          },  // this function is defined below
          new go.Binding("visible", "", function (a) { return !a.diagram.isReadOnly; }).ofObject(),
          $(go.Shape, "PlusLine", { desiredSize: new go.Size(6, 6) })
        )
      );

    this.myDiagram.nodeTemplate =
      $(go.Node, "Auto",
        { selectionAdornmentTemplate: defaultAdornment },
        new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
        // define the node's outer shape, which will surround the TextBlock
        $(go.Shape, "RoundedRectangle",
          {

            stroke: "black",
            portId: "", fromLinkable: true, toLinkable: true, cursor: "pointer",
            toEndSegmentLength: 50, fromEndSegmentLength: 40
          },
          new go.Binding("fill", "color")

        ),
        $(go.TextBlock, "Devices",
          {
            margin: 4,
            width: 80,
            textAlign: "center",
            font: "8pt helvetica, arial, sans-serif",
            stroke: "white"
          },
          new go.Binding("text", "entityDescription").makeTwoWay()
        ),
        { // second arg will be this GraphObject, which in this case is the Node itself:
          doubleClick: function (e, node) {
            thisObj.displayEntityDetails(node.data.key);
            
          },
          click: function (e, node) {
            console.log(node.data);
            node.data["location"] = node.part.location;
            thisObj.expandNode(node.data);
          }
        },
      );

    //Undesired events have a special adornment that allows adding additional "reasons"
    var UndesiredEventAdornment =
      $(go.Adornment, "Spot",
        $(go.Panel, "Auto",
          $(go.Shape, { fill: null, stroke: "dodgerblue", strokeWidth: 4 }),
          $(go.Placeholder)),
        // the button to create a "next" node, at the top-right corner
        $("Button",
          {
            alignment: go.Spot.BottomRight,
            click: addReason
          },  // this function is defined below
          new go.Binding("visible", "", function (a) { return !a.diagram.isReadOnly; }).ofObject(),
          $(go.Shape, "TriangleDown", { desiredSize: new go.Size(10, 10) })
        )
      );

    var reasonTemplate = $(go.Panel, "Horizontal",
      $(go.TextBlock, "Reason",
        {
          margin: new go.Margin(4, 0, 0, 0),
          maxSize: new go.Size(200, NaN),
          wrap: go.TextBlock.WrapFit,
          stroke: "whitesmoke",
          editable: true,
          font: smallfont
        },
        new go.Binding("text", "text").makeTwoWay())
    );

    // clicking the button on an UndesiredEvent node inserts a new text object into the panel
    function addReason(e, obj) {
      var adorn = obj.part;
      if (adorn === null) return;
      e.handled = true;
      var arr = adorn.adornedPart.data.reasonsList;
      this.myDiagram.startTransaction("add reason");
      this.myDiagram.model.addArrayItem(arr, {});
      this.myDiagram.commitTransaction("add reason");
    }

    // clicking the button of a default node inserts a new node to the right of the selected node,
    // and adds a link to that new node
    function addNodeAndLink(e, obj) {
      var adorn = obj.part;
      if (adorn === null) return;
      e.handled = true;
      var diagram = adorn.diagram;
      diagram.startTransaction("Add State");
      // get the node data for which the user clicked the button
      var fromNode = adorn.adornedPart;
      var fromData = fromNode.data;
      // create a new "State" data object, positioned off to the right of the adorned Node
      var toData = { text: "new" };
      var p = fromNode.location;
      // toData.loc = p.x + 200 + " " + p.y;  // the "loc" property is a string, not a Point object
      // add the new node data to the model
      var model = diagram.model;
      model.addNodeData(toData);
      // create a link data from the old node data to the new node data
      var linkdata = {};
      linkdata[model.linkFromKeyProperty] = model.getKeyForNodeData(fromData);
      linkdata[model.linkToKeyProperty] = model.getKeyForNodeData(toData);
      // and add the link data to the model
      model.addLinkData(linkdata);
      // select the new Node
      var newnode = diagram.findNodeForData(toData);
      diagram.select(newnode);
      diagram.commitTransaction("Add State");
    }

    var linkSelectionAdornmentTemplate =
      $(go.Adornment, "Link",
        $(go.Shape,
          // isPanelMain declares that this Shape shares the Link.geometry
          { isPanelMain: true, fill: null, stroke: "deepskyblue", strokeWidth: 0 })  // use selection object's strokeWidth
      );
    // replace the default Link template in the linkTemplateMap
    this.myDiagram.linkTemplate =
      $(go.Link,  // the whole link panel
        { selectable: true, selectionAdornmentTemplate: linkSelectionAdornmentTemplate },
        { relinkableFrom: true, relinkableTo: true, reshapable: true },
        new go.Binding("points").makeTwoWay(),
        { curve: go.Link.Bezier, toShortLength: 15 },
        new go.Binding("curviness", "curviness"),
        $(go.Shape,  // the link shape
          { stroke: "green", strokeWidth: "2" }),
        $(go.Shape,  // the arrowhead
          { toArrow: "standard", stroke: "deepskyblue" }),
        $(go.Panel, "Auto",
          $(go.Shape,  // the label background, which becomes transparent around the edges
            {
              fill: $(go.Brush, "Radial", { 0: "rgb(240, 240, 240)", 0.3: "rgb(240, 240, 240)", 1: "rgba(240, 240, 240, 0)" }),
              stroke: null
            }),
          $(go.TextBlock,  // the label text
            {
              textAlign: "center",
              font: "10pt helvetica, arial, sans-serif",
              stroke: "#555555",
              margin: 4

            },
            new go.Binding("text", "text")
          )
        )
      );

    this.entityInstancePaletteDiv =
      $(go.Palette, "myPaletteDiv",  // create a new Palette in the HTML DIV element
        {
          // share the template map with the Palette
          nodeTemplate: $(go.Node, "Auto",
            { selectionAdornmentTemplate: defaultAdornment },
            new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
            // define the node's outer shape, which will surround the TextBlock
            $(go.Shape, "Rectangle",
              {  stroke: "black",
                portId: "", fromLinkable: true, toLinkable: true, cursor: "pointer",
                toEndSegmentLength: 50, fromEndSegmentLength: 40
              },
              new go.Binding("fill", "color")),
            $(go.TextBlock, "",
              {
                margin: 6,
                font: bigfont,
                editable: false
              },
              new go.Binding("text", "entityDescription").makeTwoWay()),
            { // second arg will be this GraphObject, which in this case is the Node itself:
              click: function (e, node) {
                
              }
            }
          ),
          autoScale: go.Diagram.Uniform  // everything always fits in viewport
        });

    this.relationshipPalette =
      $(go.Palette, "relationshipPaletteDiv",  // must name or refer to the DIV HTML element
        {
          maxSelectionCount: 1,
          linkTemplate: // simplify the link template, just in this Palette
          $(go.Link,
            { // because the GridLayout.alignment is Location and the nodes have locationSpot == Spot.Center,
              // to line up the Link in the same manner we have to pretend the Link has the same location spot
              locationSpot: go.Spot.Center,
              selectionAdornmentTemplate:
              $(go.Adornment, "Link",
                { locationSpot: go.Spot.Center },
                $(go.Shape,
                  { isPanelMain: true, fill: null, stroke: "deepskyblue", strokeWidth: 0 }),
                $(go.Shape,  // the arrowhead
                  { toArrow: "Standard", stroke: null })
              )
            },
            {
              routing: go.Link.AvoidsNodes,
              curve: go.Link.JumpOver,
              corner: 5,
              toShortLength: 4
            },
            new go.Binding("points"),
            $(go.Shape,  // the link path shape
              { isPanelMain: true, strokeWidth: 2 }),
            $(go.Shape,  // the arrowhead
              { toArrow: "Standard", stroke: null }),
            $(go.Panel, "Auto",
              $(go.Shape,  // the label background, which becomes transparent around the edges
                {
                  fill: $(go.Brush, "Radial", { 0: "rgb(240, 240, 240)", 0.3: "rgb(240, 240, 240)", 1: "rgba(240, 240, 240, 0)" }),
                  stroke: null
                }),
              $(go.TextBlock,  // the label text
                {
                  textAlign: "center",
                  font: "10pt helvetica, arial, sans-serif",
                  stroke: "#555555",
                  margin: 4

                },
                new go.Binding("text", "text")
              )
            )
          ),
          model: new go.GraphLinksModel([  // specify the contents of the Palette
             ], 
             
             [
              // the Palette also has a disconnected Link, which the user can drag-and-drop
              { key: 'hasOwn', text: "hasOwn", points: new go.List(go.Point).addAll([new go.Point(0, 0), new go.Point(0, 40)]) },
              { key: 'belongTo', text: "belongTo", points: new go.List(go.Point).addAll([new go.Point(0, 0), new go.Point(0, 40)]) },
              { key: 'serves', text: "serves", points: new go.List(go.Point).addAll([new go.Point(0, 0), new go.Point(0, 40)]) }
            ])
        });
  }

  layout() {
    this.myDiagram.layoutDiagram(true);
  }
  load(myDiagram) {
    myDiagram.model = go.Model.fromJson(document.getElementById("mySavedModel")["value"]);
  }

  ChangeRelationship(relation: string) {
    var $ = go.GraphObject.make;
    this.myDiagram.linkTemplateMap.add(relation, $(go.Link,  // the whole link panel
      $(go.Shape,  // the link shape
        { stroke: "black" }),
      $(go.Shape,  // the arrowhead
        { toArrow: "standard", stroke: null }),
      $(go.Panel, "Auto",
        $(go.Shape,  // the label background, which becomes transparent around the edges
          {
            fill: $(go.Brush, "Radial", { 0: "rgb(240, 240, 240)", 0.3: "rgb(240, 240, 240)", 1: "rgba(240, 240, 240, 0)" }),
            stroke: null
          }),
        $(go.TextBlock,  // the label text
          {
            textAlign: "center",
            font: "10pt helvetica, arial, sans-serif",
            stroke: "#555555",
            margin: 4,
            text: relation
          }
          
        )
      )
    ));
  }

  hideRelationTypePanel() {
    this.IsHideRelationPanel = true;
  }

  //This method called when Add Relationship type button clicked.
  addNewRelations() {
    if (this.newRelatioName.length && !this.relationTypes.find(item => item.id.toLowerCase() === this.newRelatioName.toLowerCase())) {
      this.entityConfigurationService.saveRelationType([this.newRelatioName]).subscribe(res => {
        this.getRelationTypes();
        this.toastr.success("Relationship Type Successfully Created", "Success!");
      }, error => {
        this.toastr.error("Unable To Save Relationsip Type", "Error!");
      });

      this.newRelatioName = "";
    }
    else {
      this.toastr.error(`Relationship Type: ${this.newRelatioName} already exists`, "Error!");
    }
  }

  getEntityTypeColor(entityType: string): string {

    let entityTypeColorObj = this.colorArr.find(color => color.entityType.toLowerCase() === entityType.toLowerCase());
    return entityTypeColorObj ? entityTypeColorObj.color : "yellow";
    
  }
  populateEntityTypeColors(entityTypes: string[]) {
    entityTypes.forEach(entityType => {
      if (!this.colorArr.find(color => color.entityType.toLowerCase() === entityType.toLowerCase())) {
        var color = "rgb(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
          + Math.floor(Math.random() * 255) + ")";
        this.colorArr.push({ entityType: entityType.toLowerCase(), color: color });
      }

    });
  }
  show() {
    this.IsHideRelationPanel = !this.IsHideRelationPanel;
  }

  displayEntityDetails(key) {
    this.IsHideEntityDetails = false;
    let aa = this.myDiagram.model.nodeDataArray.find(x => x.id == key).nodeData;

    this.entityProperties = this.myDiagram.model.nodeDataArray.find(x => x.id == key).nodeData;
    let stringProperties = new Array<StringProperties>();
    let arrayProperties = new Array<ArrayProperties>();
    let timeseriesIdList = new Array<ArrayProperties>();
    Object.keys(aa).forEach(function (key) {

      if ( key == "timeseriesid" && aa[key] != "undefined" && aa[key] != "") {
        let properties = new ArrayProperties();
        properties.name = key;
        properties.value = aa[key];
        timeseriesIdList.push( properties);
      }
      else if (typeof aa[key] == 'string') {

        let curProperties = new StringProperties();
        curProperties.name = key;
        curProperties.value = aa[key];
        stringProperties.push(curProperties);
      }
      else if (aa[key] instanceof Array) {
        let properties = new ArrayProperties();
        properties.name = key;
        properties.value = aa[key];
        arrayProperties.push( properties);

      }
    });
    this.stringProperties = stringProperties;
    this.arrayProperties = arrayProperties;
    this.timeseriesIdList = timeseriesIdList;
    this.isTimeseriesExist = this.timeseriesIdList.length > 0 ? true : false;
  }
  showEntityProperties() {
    this.IsHideEntityDetails = !this.IsHideEntityDetails;
  }
  getEntitySchemaList() {
    this.entityConfigurationService.getSchemas().subscribe(res => {
      if (res) {
        this.entitySchemaList = res.map(item => item.schemaData);
        this.getEntityTypes();
      }
    }, error => {
      this.toastr.error("Unable to fetch Schema List");
    })
  }
  getRelationTypes() {
    this.entityConfigurationService.getRelationTypes().subscribe(data => {
      this.relationTypes = data.map(item => {
        return { "id": item.name, "text": item.name };
      });
    }, error => {
      this.toastr.error("Error while fetching RelationTypes", "Error!");
    })
  }
  getEntityTypes() {
    let entityTypes = this.entitySchemaList.map(item => item.title);
    this.populateEntityTypeColors(entityTypes);
    this.entityTypes = entityTypes;
  }

  OnClickEntityType(item) {
    this.selectedEntityType = item;
    this.selectedEntityInstance = null;
    this.selectedSchema = this.entitySchemaList.find(item => item.title === this.selectedEntityType);
    this.entityConfigurationService.getEntitiesByEntityType(this.selectedEntityType).subscribe(res => {
      this.entityInstances = res;
    }, error => {
      this.toastr.error(`Error while fetching data`, "Error!");
    });
  }

  OnClickEntityInstance(item) {
    this.selectedEntityInstance = item;
  }

  createEntityInstancePallete() {
    this.entityInstancePaletteDiv.nodeDataArray = [];
    var yellowgrad = this.$(go.Brush, "Linear", { 0: "rgb(254, 201, 0)", 1: "rgb(254, 162, 0)" });
    var greengrad = this.$(go.Brush, "Linear", { 0: "#98FB98", 1: "#9ACD32" });
    var bluegrad = this.$(go.Brush, "Linear", { 0: "#B0E0E6", 1: "#87CEEB" });
    var redgrad = this.$(go.Brush, "Linear", { 0: "#C45245", 1: "#871E1B" });
    var whitegrad = this.$(go.Brush, "Linear", { 0: "#F0F8FF", 1: "#E6E6FA" });
    this.entityInstancePaletteDiv.model.nodeDataArray = this.entityInstances.map(item => {
      return { key: item.id, entityDescription: item.name, id: item.id, entityType: item.type, color: redgrad };
    });
  }

  savedDiagram: any;
  // Show the diagram's model in JSON format
  save(myDiagram) {
    this.savedDiagram = myDiagram.model.toJson();
    myDiagram.isModified = false;
  }


  highlight(node) {  // may be null
    var oldskips = this.myDiagram.skipsUndoManager;
    this.myDiagram.skipsUndoManager = true;
    this.myDiagram.startTransaction("highlight");
    if (node !== null) {
      this.myDiagram.highlight(node);
    } else {
      this.myDiagram.clearHighlighteds();
    }
    this.myDiagram.commitTransaction("highlight");
    this.myDiagram.skipsUndoManager = oldskips;
  }
  dragged: any;
  dragStart($event, key: string, type: string) {
    $event.dataTransfer.setData("key", key/**/);
    $event.dataTransfer.setData("type", type);
    this.dragged = $event.target;
  }
  dragOverOnDiagram(event) {
    
    var can = event.target;
    var pixelratio = window.devicePixelRatio;

    // if the target is not the canvas, we may have trouble, so just quit:
    if (!(can instanceof HTMLCanvasElement)) return;

    var bbox = can.getBoundingClientRect();
    var bbw = bbox.width;
    if (bbw === 0) bbw = 0.001;
    var bbh = bbox.height;
    if (bbh === 0) bbh = 0.001;
    var mx = event.clientX - bbox.left * ((can.width / pixelratio) / bbw);
    var my = event.clientY - bbox.top * ((can.height / pixelratio) / bbh);
    var point = this.myDiagram.transformViewToDoc(new go.Point(mx, my));
    var curnode = this.myDiagram.findPartAt(point, true);
    if (curnode instanceof go.Node || curnode instanceof go.Link) {
      this.highlight(curnode);
    } else {
      this.highlight(null);
    }
    
    // Allow a drop on everything else
    event.preventDefault();
  }

  dropOnDiagram(event) {
    // prevent default action
    // (open as link for some elements in some browsers)
    event.preventDefault();

    // Dragging onto a Diagram
    var can = event.target;
    var pixelratio = window.devicePixelRatio;

    // if the target is not the canvas, we may have trouble, so just quit:
    if (!(can instanceof HTMLCanvasElement)) return;

    var bbox = can.getBoundingClientRect();
    var bbw = bbox.width;
    if (bbw === 0) bbw = 0.001;
    var bbh = bbox.height;
    if (bbh === 0) bbh = 0.001;
    var mx = event.clientX - bbox.left * ((can.width / pixelratio) / bbw);
    var my = event.clientY - bbox.top * ((can.height / pixelratio) / bbh);
    var point = this.myDiagram.transformViewToDoc(new go.Point(mx, my));
    let key = event.dataTransfer.getData("key");
    let type = event.dataTransfer.getData("type");
    this.myDiagram.startTransaction('new ' + type);

    if (type === "Node") {
      let actualData = this.entityInstances.find(item => item.id === key);
      let existingNode = this.myDiagram.model.nodeDataArray.find(item => item.key === key);
      if (actualData && !existingNode) {
        var bluegrad = this.$(go.Brush, "Linear", { 0: "#B0E0E6", 1: "#87CEEB" });
        this.myDiagram.model.addNodeData({ loc: point, key: actualData.id, entityDescription: actualData.name, id: actualData.id, entityType: actualData.type, nodeData: actualData, color: this.$(go.Brush, { color: this.getEntityTypeColor(actualData.type) }) });
      }
    }
    else if (type === "Link") {
      let relation = this.relationTypes.find(item => item.id === key);
      this.myDiagram.model.addLinkData({ isNewLink:true, key: this.myDiagram.model.linkDataArray.length + 1, id: relation.id, text: relation.text, points: new go.List(go.Point).addAll([new go.Point(0, 0), new go.Point(0, 40)]) });
    }
    this.myDiagram.commitTransaction('new ' + type);
  }
  expandNode(parentNode: any) {

    if (parentNode["isExpand"]) {
      return;
    }
    let nodeArray = [];
    let linkArray = [];
    this.entityConfigurationService.getEntityRelationshipsBySourceId(parentNode.id).subscribe(res => {
      console.log(res);
      this.entityConfigurationService.getEntitesByRelationships(res).subscribe(listOfentities => {
        parentNode["isExpand"] = true;
        console.log(listOfentities);
        listOfentities.forEach(item => {
          if (item.constructor === Array) {
            nodeArray = nodeArray.concat(item);
          }
          else {
            nodeArray.push(item);
          }
        })
        nodeArray = nodeArray.filter(node => {
          return !this.myDiagram.model.nodeDataArray.find(item => item.key === node.id)
        })
        linkArray = res.filter(relation => {
          return !this.myDiagram.model.linkDataArray.find(item => item.key === relation.id)
        });
        
        this.createDataforChart(parentNode, nodeArray, linkArray);
      })
    })
  }
  createDataforChart(parentNode: any, nodes, entityRelationships) {
    var count = 0;
    nodes.forEach(element => {
      var axes = new go.Point(Math.random() * 600, Math.random() * 300);
      var obj = element ? element : element[0];
      let location = this.getPointPosition(parentNode, obj, count);
      let loc = `${location.xAxis} ${location.yAxis}`;
      this.myDiagram.model.addNodeData(
        { loc: loc, key: obj.id, entityDescription: obj.name, nodeData: obj, id: obj.id, entityType: obj.type, color: this.$(go.Brush, { color: this.getEntityTypeColor(obj.type) }) });
      count = count + 1;
    });

    entityRelationships.forEach(element => {
      var linkNode =
        {
          "from": element.sourceentityid, "to": element.destinationentityid, "text": element.relationshiptype, "key": element.id, id: element.id
        }
      this.myDiagram.model.addLinkData(linkNode);
    });

  }

  getPointPosition(parentNode, node, childNumber: number): any {

    //Root Node   
    let parentX = parentNode["location"].x;
    let parentY = parentNode["location"].y;
    
    return { xAxis: (parentX + (childNumber * 130) - 150), yAxis: (parentY + 120) };
  }

  //This method called when Upload Entities is clicked.
  FileChangeEvent(fileInput: any) {
    let CurrentFile = fileInput.target.files[0];

    let reader = new FileReader();

    reader.onload = () => {
      try {
        let entityList = JSON.parse(reader.result);
        let schemaList = this.entityConfigurationService.prepareAndGetValidSchemaFromEntityList(entityList);
        if (schemaList && schemaList.length > 0) {
          this.selectedEntityType = null;
          this.selectedSchema = null;
          this.selectedEntityInstance = null;
          this.entityConfigurationService.saveSchema(schemaList).subscribe(res => {
            this.toastr.success('Schema Uploaded Successfully!', 'Success!');
            this.getEntitySchemaList();

          }, error => {
            this.toastr.error(error, 'Error!');
          })
        }

        if (entityList) {
          this.entityConfigurationService.saveEntities(entityList.constructor === Object ? [entityList] : entityList).subscribe(res => {
            this.toastr.success("Entity Instances Created Successfully", "Success!");
          }, error => {
            this.toastr.error(error, "Error!");
          })
        }


        console.log(entityList);
        console.log(`Data Uploaded from JSON file : ${reader.result}`);
      }
      catch (e) {
        this.toastr.error('Invalid file data !', 'Error!');
      }

    };
    reader.readAsText(CurrentFile);

  }


  //When Save Entities Button clicked this method is being called.
  SaveEntityDiagramRelations() {
    try {
      let relations = this.myDiagram.model.linkDataArray.map(link => {

        let sourceType = this.myDiagram.model.nodeDataArray.find(node => node.id === link.from).entityType;
        let destinationType = this.myDiagram.model.nodeDataArray.find(node => node.id === link.to).entityType;
        return {
          "id": link["isNewLink"]? UUID.UUID():link.id,
          "relationshiptype": link.text,
          "sourceentityid": link.from,
          "destinationentityid": link.to,
          "sourceEntityType": sourceType,
          "destinationEntityType": destinationType
        };
      });
      console.log(relations);
      
      if(relations != null){
      
        this.entityConfigurationService.saveRelationships(relations).subscribe(res => {
        this.toastr.success("Entity Relationships Saved Successfully!", "Success!");        
        let linksTobeDeleted=this.relationsTobeDeleted.filter(item=>!item["isNewLink"]);
        this.myDiagram.model.linkDataArray.forEach(item=>{
          item["isNewLink"]=false;
        })
          if(linksTobeDeleted.length>0){
          this.entityConfigurationService.deleteRelationships(linksTobeDeleted.map(item=>item.id)).subscribe(res=>{
              this.toastr.success("Entity Relationships deleted Successfully!", "Success!");
              this.relationsTobeDeleted=[];
          },error=>{
            this.toastr.error("Unable To delete Entity Relationships", "Error!");
            this.relationsTobeDeleted=[];
          })
        }
      }, error => {
        this.toastr.error("Unable To Save Entity Relationships", "Error!");
      });

      }
      else {
        this.toastr.error(" No valid entities to save!!", " Error!");
      }
    }
    catch (error) {
      this.toastr.error("Connect nodes properly, some nodes are still disconnected.", "Error!")
    }
  }
  openAddRelationTypeDialog(content) {
    this.modalService.open(content, { backdrop: "static" });

  }
  OnSchemaAdd(data) {
    this.getEntitySchemaList();

  }
  onSaveEntityRegister(entity) {

    this.OnClickEntityType(this.selectedEntityType);
    let nodes = this.myDiagram.model.nodeDataArray.filter(item => item.id === entity.id);
    let model = this.myDiagram.model;
    nodes.forEach(node => {
      model.startTransaction("Start modifying data");
      model.setDataProperty(node, "entityDescription", entity.name);
      model.commitTransaction("Start modifying data");
    });

  }
  CreateCustomeEntity() {
    document.getElementById("createCustomeEntityModel").style.display = "block";
  }

}
export class StringProperties {
  name: string;
  value: string;
}

export class ArrayProperties {
  name: string;
  value: any;
}